/**
 * src/pages/WhereDidWeComeFrom/sections/CosmicTimelineSection.tsx
 * Section 2: "13.8 Billion Years" deep time scrub timeline with log-scaling
 * and explicit open-question epistemology regarding what came before.
 */

import React from "react";
import { ScrubTimeline } from "@/components/originBeyond/ScrubTimeline";
import { SectionHeading } from "@/components/cosmic/SectionHeading";
import { DisclaimerNote } from "@/components/originBeyond/DisclaimerNote";
import { COSMIC_TIMELINE } from "../whereDidWeComeFromData";
import "@/components/cosmic/cosmic.css";
export function CosmicTimelineSection() {
  return <section id="cosmic-timeline" className="w-full max-w-[76rem] mx-auto px-4 sm:px-6 lg:px-8 min-w-0" aria-label="Cosmic Deep Time Evolution">
      <SectionHeading eyebrow="Chronological Telemetry" title="13.8 Billion Years: From Singularity to Modern Earth" description="Trace the logarithmic arc of cosmic history. Our physical models reconstruct the universe from fractions of a second forward; the origin of the expansion itself remains an open boundary." />

      {/* Epistemological disclaimer note */}
      <div className="mb-8">
        <DisclaimerNote tone="science" title="The Limits of Current Cosmology">
          General relativity and quantum field theory describe the early expanding cosmos with extraordinary fidelity from roughly 10⁻³² seconds onward. However, science does not currently know what (if anything) preceded the expansion or why it initiated. Questions about &ldquo;before&rdquo; the Big Bang remain speculative and open theoretical frontiers.
        </DisclaimerNote>
      </div>

      {/* ScrubTimeline Interactive Component */}
      <ScrubTimeline events={COSMIC_TIMELINE} ariaLabel="13.8 billion years cosmic evolution timeline" trackLabelStart="10⁻³² s (Inflation)" trackLabelEnd="Present (~13.8 Gyr)" className="mb-8" />
    </section>;
}